// extracted by mini-css-extract-plugin
export default {"SkillsTitle":"Skills_SkillsTitle__eDQ5T","SkillsList":"Skills_SkillsList__PxfRK","SkillsGroup":"Skills_SkillsGroup__E7CYJ"};